import { createDynamicThunk } from ".";

/**
 * LIST Processes
 */
export const fetchProcessesThunk = createDynamicThunk({
  typePrefix: "processes/fetchProcessesThunk",
  useHandleSearch: true,
});

/**
 * ADD / EDIT Process
 */
export const submitProcessThunk = createDynamicThunk({
  typePrefix: "processes/submitProcessThunk",
  endpoint: "/processes",
  method: "POST",
});
